import type { GetDistributionConnectionsByIdResponse } from 'wg-api-sdk';

import { SUPPORTED_CRMS } from '@/constants/crm';
import useBrokerIntegrations from '@/queries/hooks/useBrokerIntegrations';
import useCurrentBroker from '@/queries/hooks/useCurrentBroker';
import useDistributionConnections from '@/queries/hooks/useDistributionConnections';
import useMe from '@/queries/hooks/useMe';

const mapConnectionToCrm = (
  connection: GetDistributionConnectionsByIdResponse['connections'][number],
) => {
  if (connection.key === 'brio_api') {
    return {
      key: 'brio',
      name: 'Brio',
    };
  }

  return connection;
};

export default function useBroker() {
  const { data: me, isLoading: isLoadingMe } = useMe();
  const { data: broker, isLoading: isLoadingBroker } = useCurrentBroker();
  const { data: integrations, isLoading: isLoadingIntegrations } =
    useBrokerIntegrations(broker?.id ?? '', { enabled: Boolean(broker?.id) });
  const { data: connections, isLoading: isLoadingConnections } =
    useDistributionConnections(broker?.distribution_id ?? '', {
      enabled: Boolean(broker?.distribution_id),
    });

  const crms = connections
    ?.filter(
      (connection) =>
        SUPPORTED_CRMS.includes(connection.key) && connection.active,
    )
    .map(mapConnectionToCrm);

  return {
    me,
    broker,
    integrations,
    connections,

    isLoading:
      isLoadingMe ||
      isLoadingBroker ||
      isLoadingIntegrations ||
      isLoadingConnections,

    crms,
  };
}
